import React from 'react'
import PropTypes from 'prop-types'
import dayjs from '../../../../../../utilities/dayjs'
import { Link } from 'react-router-dom'
import CursorPagination from '../../../../../../components/cursor-pagination'
import ActivityIcon from '../../../../../shared/ActivityIcon'

export default function ResourceActivitiesDisplay (props) {
  const { activities, onPageRequest, fakeCount } = props

  return (
    <div className='row panel panel-default'>
      <div className='panel-heading'>
        <div className='container-fluid'>
          <div>
            <h4 className='pull-left'>Asset Activities</h4>
          </div>
        </div>
      </div>
      <div className='panel-body'>
        <div className='list-group'>

          {(() => activities.nodes?.map((activityWrapper) => {
            const activity = activityWrapper
            const comment = activity.key === 'ticket.add_comment'
            const listItemClasses = `list-group-item ${comment ? 'highlight-bg' : ''}`
            return (
              <li className={listItemClasses} key={activity.id}>
                <div className='pull-left font-size-1-25em'>
                  {comment ? `Comment: ${activity.message}` : activity.message}
                </div>
                <ActivityIcon iconName={activity.key} />
                <div className='clearfix' />

                <h6 className='pull-right'>
                  {dayjs(activity.createdAt).format('dddd, MMMM Do YYYY, h:mm:ss a')}
                </h6>
                <h6 className='text-left'>
                  <em>
                    By
                    <Link to={`/hauler/team/${activity.authorId}`}>
                      {` ${activity.author}`}
                    </Link>
                  </em>
                </h6>
              </li>
            )
          }))()}
        </div>
      </div>
      <div className='panel-footer'>
        <CursorPagination
          pageInfo={activities.pageInfo}
          totalCount={activities.totalCount}
          onPageRequest={onPageRequest}
          fakeCount={fakeCount}
        />
      </div>
    </div>
  )
}

ResourceActivitiesDisplay.propTypes = {
  activities: PropTypes.shape({
    nodes: PropTypes.arrayOf(PropTypes.object).isRequired,
    pageInfo: PropTypes.shape({
      endCursor: PropTypes.string,
      hasNextPage: PropTypes.bool.isRequired,
      hasPreviousPage: PropTypes.bool.isRequired,
      startCursor: PropTypes.string
    }).isRequired,
    totalCount: PropTypes.number.isRequired
  }).isRequired,
  onPageRequest: PropTypes.func.isRequired,
  fakeCount: PropTypes.shape({
    start: PropTypes.number.isRequired,
    end: PropTypes.number.isRequired
  })
}
